import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({ action, loading, selectedFiles }) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        startIcon={<DownloadIcon />}
        onClick={action}
        size="small"
        variant="text"
        color="inherit"
        disabled={loading || selectedFiles.length === 0}
      >
        {t('buttons.download', { ns: 'fileBrowser' })}
      </Button>
    </>
  );
};

DownloadButton.propTypes = {
  action: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  selectedFiles: PropTypes.array.isRequired,
};

export default DownloadButton;
